import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useAccessRoleUIContext } from "./AccessRoleUIContext";
import { AccessRoleFilter } from "./access-role-table/access-role-filter/AccessRoleFilter";
import { fetchAccessRoles } from "../../_redux/access-role/accessRoleAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import AccessRoleTable from "./access-role-table/AccessRoleTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { Collapse } from "react-bootstrap";
import { RoleChecker } from "../../../../RoleChecker";

export const AccessRoleCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();

  const [openFilter, setOpenFilter] = useState(false);

  // * AccessRole UI Context
  const accessRoleUIContext = useAccessRoleUIContext();
  const accessRoleUIProps = useMemo(() => {
    return {
      queryParams: accessRoleUIContext.queryParams,
      setQueryParams: accessRoleUIContext.setQueryParams,
      openEditAccessRolePage: accessRoleUIContext.openEditAccessRolePage,
      newAccessRoleButtonClick: accessRoleUIContext.newAccessRoleButtonClick
    };
  }, [accessRoleUIContext]);

  // * Getting curret state of accessRole list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminAccessRole,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke AccessRole Action
    dispatch(fetchAccessRoles(accessRoleUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessRoleUIProps.queryParams, dispatch]);

  const allowCreate = RoleChecker("Create", "master_data_access_role");
  const allowEdit = RoleChecker("Edit", "master_data_access_role");

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title="Akses Role">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
            {allowCreate && (
              <button
                type="button"
                className="btn mx-1 btn-primary"
                onClick={() => {
                  accessRoleUIProps.newAccessRoleButtonClick();
                }}
              >
                Tambah Akses Role
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div className="collapse-filter">
              <AccessRoleFilter />
            </div>
          </Collapse>
          <AccessRoleTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={accessRoleUIProps.queryParams}
            setQueryParams={accessRoleUIProps.setQueryParams}
            openEditAccessRolePage={accessRoleUIProps.openEditAccessRolePage}
            allowEdit={allowEdit}
          />
        </CardBody>
      </Card>
    </>
  );
};
